import { createAsyncThunk } from '@reduxjs/toolkit';

import { setAuthHeader, setUserHeader } from '../../../http/headers';

export type ProcessAuthTokenInput = { token: string; email: string };
export type ProcessAuthTokenResult = { email: string; token: string };

/**
 * Stores the access token + user email in the slice and on the global axios
 * headers. The caller (host app's AuthProvider — typically powered by
 * `oidc-client-ts`) is responsible for parsing the JWT and supplying the
 * email. This deliberately avoids decoding the token in the lib so we don't
 * force a `jwt-decode` dependency for an operation the OIDC client already
 * does for free.
 */
export const processAuthToken = createAsyncThunk<ProcessAuthTokenResult, ProcessAuthTokenInput>(
  'app/processAuthToken',
  async ({ token, email }) => {
    if (!email) {
      throw new Error('processAuthToken: email is required');
    }
    setAuthHeader(token);
    setUserHeader(email);
    return { email, token };
  },
);
